import { render, staticRenderFns } from "./DisqualificationPickupModal.vue?vue&type=template&id=1c351ebf&scoped=true"
import script from "./DisqualificationPickupModal.vue?vue&type=script&lang=js"
export * from "./DisqualificationPickupModal.vue?vue&type=script&lang=js"
import style0 from "./DisqualificationPickupModal.vue?vue&type=style&index=0&id=1c351ebf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c351ebf",
  null
  
)

export default component.exports